"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var socket_io_module_1 = require("./socket-io.module");
exports.SocketIoModule = socket_io_module_1.SocketIoModule;
var socket_io_service_1 = require("./socket-io.service");
exports.Socket = socket_io_service_1.WrappedSocket;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-socket-io/index.js
// module id = ./node_modules/ng-socket-io/index.js
// module chunks = vendor